module.exports = __webpack_public_path__ + "sovdapp/img/footer-logo1-gray.68c0a78.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer-logo1-gray.svg
// module id = lU+J
// module chunks = 1 2 3